import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { StatusDocumento } from '../models/status-documento.model';
import { EventoRepository, EVENTO_REPOSITORY } from '../repositories/evento.repository';

@Injectable({
  providedIn: 'root'
})
export class ListarTiposFeedbacksDocumentoUseCase {
  constructor(
    @Inject(EVENTO_REPOSITORY) private readonly repository: EventoRepository
  ) {}

  execute(): Observable<StatusDocumento[]> {
    return this.repository.listarTiposFeedbacksDocumento();
  }
}
